import React from 'react'
import styled from 'styled-components'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const Testimonial = () => {
    const settings = {
        // dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
  return (
    <>
      <Wrapper>
        <div className="container">
        <section className='testimonial'>
        <Slider {...settings} className='slider'>
          <div className='content'>
           <img src="./Images/testi.png" alt="" width={30}/>
           <div className="details">
            <p>Arslan is just an amazing person! This is my 6th time working with him and I have referred a lot of people to him too. He’s one of my favorite to work with on Fiverr. He is patient, understanding, knowledgeable and always ready to listen to you. I definitely will be working with him again very soon. Thank you Arslan! God bless you.</p>
           </div>
           <div className="image">
            <img src="./Images/person.png" alt="" width={100}/>
           </div>
           <div className="name">
            <h1>Jodan James</h1>
           </div>
          </div>
          <div className='content'>
          <img src="./Images/testi.png" alt="" width={30}/>
           <div className="details">
            <p>I rarely leave reviews, but truly, Arslan is a rare gem! He scheduled meetings on more than one occasion via zoom despite the time difference and was able to bring our concept to life. There were a number of revisions needed throughout the process and these were promptly completed. As a new business, I’m extremely grateful for Arslan services</p>
           </div>
           <div className="image">
            <img src="./Images/person2.png" alt="" width={100}/>
           </div>
           <div className="name">
            <h1>Jodan James</h1>
           </div>
          </div>
          <div className='content'>
          <img src="./Images/testi.png" alt="" width={30}/>
           <div className="details">
            <p>I really can't thank thank Arslan enough for the work he has done for me. Not only is the quality of the work extremely high, but Arslan also makes the entire process super easy to understand, which is great if you are not super techy like myself.</p>
           </div>
           <div className="image">
            <img src="./Images/person3.png" alt="" width={100}/>
           </div>
           <div className="name">
            <h1>Jodan James</h1>
           </div>
          </div>
        </Slider>
        </section>
        </div>
        <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default Testimonial

const Wrapper = styled.section`
.container{
    width: 100%;
    height: auto;
    background-image: url("./Images/testimonial.png");
    background-position: center;
    background-size: cover;
    padding-left: 7.5%;
    padding-right: 7.5%;
    padding-top: 5%;
    padding-bottom: 5%;
    /* background-attachment: fixed; */
}
.content img{
   margin: auto;
}

.details p{
    padding-top: 40px;
    margin: auto;
    width: 60vw;
}
.image{
    margin-top: 50px;
}
.name h1{
    text-align: center;
    color: rgba(255, 204, 0, 1);
    margin-top: 20px;
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}

@media (max-width: 768px) {
    .container{
        padding-top: 10%;
        padding-bottom: 10%;
        padding-left: 10%;
        padding-right: 10%;
    }
    .details p{
        font-size: 16px;
        width: 70vw;
    }
    .image img{
        width: 70px;
    }
    .container{
    background-attachment: scroll;
}
}

`
